import React, { useCallback, useContext } from 'react'
import cn from 'classnames'

import { SectionContent } from '../../../../lib/types/section'
import { ContentRenderer } from '../../../renderer'
import { useFirstEnterViewport } from '../../../ui-lib/hooks/viewport-tracker'
import { PageContext } from '../../../../contexts/page-context'
import { gnarSpec } from '../../../../lib/tracking/gnar'

import styles from '../parallax.module.scss'

interface ParallaxSlideScrollingColumnProps {
  id: string
  content: SectionContent
  slideSectionInternalName: string
}

export const ParallaxSlideScrollingColumn = React.forwardRef<HTMLDivElement, ParallaxSlideScrollingColumnProps>(
  ({ id, content, slideSectionInternalName }, ref) => {
    const { pageId, slug, isSectionScrollTrackingEnabled } = useContext(PageContext)

    const onFirstEnter = useCallback(() => {
      if (isSectionScrollTrackingEnabled) {
        gnarSpec.sectionScroll(slideSectionInternalName, pageId, slug)
      }
    }, [isSectionScrollTrackingEnabled, pageId, slideSectionInternalName, slug])

    useFirstEnterViewport(ref, onFirstEnter, 0.5)

    return (
      <div ref={ref} id={id} className={styles.scrollingCopySlide}>
        <ContentRenderer structure={content} />
      </div>
    )
  }
)

interface ParallaxSlideFixedColumnProps {
  scrollingSlideId: string // used for a11y to associate fixed slide to corresponding scrolling slide
  content: SectionContent
  isActive: boolean
}

export const ParallaxSlideFixedColumn: React.FC<ParallaxSlideFixedColumnProps> = ({
  scrollingSlideId,
  content,
  isActive,
}) => {
  return (
    <div
      className={cn(styles.slideAsset, isActive && styles.activeSlideAsset)}
      aria-hidden={!isActive}
      aria-describedby={scrollingSlideId}
    >
      <ContentRenderer structure={content} />
    </div>
  )
}
